export default __webpack_public_path__ + "static/media/rigthArrow.7efab1f9.svg";